<template>
  <v-container
    fluid
    pa-0
    fill-height
    class="align-start"
    style="max-width: 100%"
  >
    <div class="d-flex flex-column flex-grow-1 fill-height">
      <LinkDeviationDelayTable v-if="!$apollo.loading" />
    </div>
  </v-container>
</template>

<script>
import LinkDeviationDelayTable from '@/modules/linkDeviation/components/delay/LinkDeviationDelayTable'

export default {
  name: 'LinkDeviationDelays',

  components: {
    LinkDeviationDelayTable
  }
}
</script>
